import { defineMessages } from 'react-intl';

export const imageDetailViewMessages = defineMessages({
  next: { id: 'imageDetailView.next', defaultMessage: 'Next Image' },
  previous: { id: 'imageDetailView.previous', defaultMessage: 'Previous Image' },
  zoomIn: { id: 'imageDetailView.zoomIn', defaultMessage: 'Zoom In Image' },
  zoomOut: { id: 'imageDetailView.zoomOut', defaultMessage: 'Zoom Out Image' },
  close: { id: 'imageDetailView.close', defaultMessage: 'Close Preview' },
});
